import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { CustomerContactRequest } from '../models/CustomerContactRequest.model';

@Injectable({
  providedIn: 'root'
})
export class EmailService {
  private readonly baseUrl = `${environment.apiUrl}/email`;

  constructor(private http: HttpClient) {}

  sendCustomerContactRequest(request: CustomerContactRequest): Observable<boolean> {
    return this.http.post<boolean>(`${this.baseUrl}/cust-contact`, request);
  }
}
